<template>
	<div class="row">
		<div class="col-12" :class="`col-sm-${settings.columnSize} ${settings.class}`" v-for="(metaData, index) in metaDatas" :key="index">
			<nk-col-form-group :label="metaData.metaDataSchema.name.toLocaleDigits() + ':'" :labelSizes="settings.labelSizes" :dataSizes="settings.dataSizes" :labelAligns="settings.labelAligns">
				<component :options="getOptions(metaData)" :is="metaData.metaDataSchema.type" v-model="metaData.value" :tabindex="tabindex + index" />
			</nk-col-form-group>
		</div>
	</div>
</template>

<script>
	import input from '../../general/nikan-input.vue'
	import Dropdown from '~/components/general/dropdown.vue'
	import _ from 'lodash'
	import Switch from '~/components/general/nikan-switch.vue'
	import date from '~/components/general/nikan-date.vue'
	import { mapActions } from 'vuex'
	import EmptyId from '../../../statics/empty-id'
	import TabOrder from '@/statics/taborder-functions'

	export default {
		components: {
			String: input,
			Integer: input,
			Float: input,
			Boolean: Switch,
			Date: date,
			List: Dropdown
		},
		props: {
			options: Object,
			tabindex: { type: [String, Number], default: 150 },
		},
		data() {
			return {
				settings: {
					prefix: 'metaData',
					labelAligns: { lg: 'right', md: 'right', sm: 'right' },
					dataSizes: { sm: 12 },
					labelSizes: { sm: 12 },
					columnSize: 6
				},
				metaDatas: []
			}
		},
		watch: {
			options: {
				deep: true,
				immediate: true,
				handler(val, oldVal) {
					this.settings = _.extend(this.settings, val)
					this.refresh()
				}
			}
		},
		mounted() {
			this.settings = _.merge(this.settings, this.options)
		},
		methods: {
			...mapActions({
				getBySubject: 'metadata/getBySubject'
			}),
			commitData() {
				return this.metaDatas.filter(x => x.value !== undefined && x.value !== '').map(x => _.merge(x, { value: x.value.toString() }))
			},
			getOptions(metaData) {
				let options = { mode: 'string' }

				switch (metaData.metaDataSchema.type) {
					case 'Integer':
						options.mode = 'number'
						break

					case 'Float':
						options.mode = 'decimal'
						break

					case 'List':
						options.getDataFromOptions = true
						options.data = metaData.metaDataSchema.csValues.split(',')
						break

					default:
						break
				}
				return options
			},
			async refresh() {
				this.getBySubject(this.settings.prefix + '_' + this.settings.subject).then(schemas => {
					schemas = (schemas || []).sort((a, b) => (a.displayOrder > b.displayOrder) ? 1 : -1)
					let items = []
					for (var i = 0; i < schemas.length; i++) {
						let found = this.settings.data.find(x => x.metaDataSchema && x.metaDataSchema.name === schemas[i].name)
						let value = ''
						switch (schemas[i].type) {
							case 'Boolean':
								value = found ? found.value : true
								break
							default:
								value = found ? found.value : ''
						}
						let tmp = {
							id: found ? found.id : EmptyId,
							entityType: found ? found.entityType : '',
							entityId: found ? found.entityId : EmptyId,
							companyId: found ? found.companyId : EmptyId,
							value: found ? found.value : value,
							metaDataSchema: _.extend({}, schemas[i])
						}
						items.push(tmp)
					}
					this.metaDatas = items
					this.defer(() => {
						let grandParentType = this.grandParentType()
						TabOrder.subscribeKeys(grandParentType, this)
					}, 500)
				})
			}
		}
	}
</script>

<style></style>
